import { Box } from '@interstate/components/Box';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import styled from 'styled-components';

export const StyledPriceInputContainer = styled(Box)`
    @media (min-width: ${BreakPoint.PHONE}) {
        margin-right: 0.5rem;
    }
`;

export const StyledPriceInputBaseContainer = styled(Box)`
    padding-top: 1rem;
    margin-right: 0.8rem;
`;

export const StyledTaxesContainer = styled(Box)<{ removeBorder: boolean }>`
    border-top: ${({ theme, removeBorder }) =>
        removeBorder ? 'none' : `${theme.tokens.BaseSizeBorderPx} solid ${theme.tokens.SemColorBorderMuted}`};
    padding: 0.5rem 0.3rem 0.3rem 0.3rem;
`;

export const StyledTaxName = styled(Box)`
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    padding-right: 0.8rem;
`;
